/**
 * Model to manage rules mapping related data.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class RuleGroupMappingFunctionality {
    id: number;
    functionalityId: number;
    ruleGroupId: number;
    ruleGroupName: string;
}



// WEBPACK FOOTER //
// ./src/app/admin/rules/rule-group-functionality.model.ts